import { FC, useContext } from 'react';

import { filterInvalidChildren } from '../Common/Tabs/filterInvalidChildren';
import { ActiveTabContext } from '../Common/Tabs/TabProvider';
import { Tab } from '../Common/Tabs/Tab';
import { useTabList } from '../Common/Tabs/useTabList';
import { CommonList } from '../Common/Tabs/CommonList';
import { TabConfigArray, Padding, Font } from '../Common/Tabs/sharedTypes';

type Props = {
    automaticActivation?: boolean;
    animate?: boolean;
    onTabActivate?: (name: string) => void;
    children?: TabConfigArray;
    underline?: boolean;
    indicatorPadding?: Padding;
    indicatorHeight?: '1px' | '2px';
    activeFont?: Font;
    inactiveFont?: Font;
    contrast?: boolean;
    customTab?: boolean;
    align?: 'center' | 'left';
    fullWidth?: boolean;
};

export const TabList: FC<Props> = ({
    children = [],
    animate = true,
    automaticActivation,
    onTabActivate = () => {},
    indicatorPadding,
    indicatorHeight,
    underline,
    activeFont,
    inactiveFont,
    contrast,
    customTab,
    align,
    fullWidth,
}) => {
    const validChildren = children.filter(filterInvalidChildren);

    const { activeTab } = useContext(ActiveTabContext) || {};
    const tabNames = children.filter(filterInvalidChildren).map(([name]) => name);

    const tabListProps = useTabList(tabNames, onTabActivate, automaticActivation);

    return (
        <CommonList
            contrast={contrast}
            animate={animate}
            underline={underline}
            indicatorPadding={indicatorPadding}
            indicatorHeight={indicatorHeight}
            align={align}
            fullWidth={fullWidth}
            {...tabListProps}
        >
            {validChildren.map(([name, component]) =>
                customTab ? (
                    component
                ) : (
                    <Tab
                        contrast={contrast}
                        active={name === activeTab}
                        activeFont={activeFont}
                        inactiveFont={inactiveFont}
                        key={name}
                        name={name}
                        onActivate={() => onTabActivate?.(name)}
                    >
                        {component}
                    </Tab>
                )
            )}
        </CommonList>
    );
};
